import styled from 'styled-components';

import { NorlysFont } from '~src/branding';
import { Heading } from '~src/components/Typography';
import { useDisplay } from '~src/hooks/useDisplay';

import { CheckmarkOutlined } from '../Products/ProductCard/style';

const BulletPointsWrapper = styled.div(() => {
  const { isMobile } = useDisplay();

  if (isMobile) {
    return {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gap: '1rem',
      height: 'fit-content',
    };
  }

  return {
    display: 'grid',
    gridTemplateColumns: 'auto',
    gap: '2rem',
    height: 'fit-content',
    marginBottom: '1rem',
  };
});

const BulletPoint = styled.div({
  display: 'flex',
  alignItems: 'center',
});

type BulletPointsType = { title?: string; entries: string[] };

export const BulletPoints = ({ title, entries }: BulletPointsType) => {
  const { isMobile } = useDisplay();

  return (
    <BulletPointsWrapper>
      {!!title && (
        <Heading style={{ ...(isMobile && { gridColumn: 'span 3', justifySelf: 'left', width: '100%' }) }} level={3}>
          {title}
        </Heading>
      )}

      {entries.map(entry => (
        <BulletPoint key={entry}>
          <CheckmarkOutlined />

          <Heading level={3}>{entry}</Heading>
        </BulletPoint>
      ))}
    </BulletPointsWrapper>
  );
};

export const BulletPointsNorlys = ({ title, entries }: BulletPointsType) => (
  <BulletPointsWrapper>
    <Heading style={{ ...NorlysFont.style('heading', 16) }} level={3}>
      {title}
    </Heading>

    {entries.map(entry => (
      <BulletPoint key={entry}>
        <CheckmarkOutlined />

        <Heading style={{ ...NorlysFont.style('heading', 16) }} level={3}>
          {entry}
        </Heading>
      </BulletPoint>
    ))}
  </BulletPointsWrapper>
);
